module.exports = __webpack_public_path__ + "img/micon-3.247cbec0.svg";